import http from '@/backend/http'

/**
 * Per-member notification preferences.
 *
 * A dedicated module rather than the generic `accounts/LIST` abstraction: that
 * one assumes a paginated list and writes `<resource>List` / `<resource>Count`
 * from `response.data.results`, while this endpoint answers with a single
 * object (`{ muted, email_digest, preferences }`).
 *
 * The API returns the catalog already merged with the member's overrides, so
 * the client never has to know which notification types exist.
 */
const url = '/notifications/preferences/'

const state = {
  settings: null,
  loading: false,
  saving: false
}

const actions = {
  RETRIEVE: ({ commit }) => {
    commit('SET_LOADING', true)
    return http.get(url)
    .then(response => {
      commit('SET_SETTINGS', response.data)
      return response.data
    })
    .finally(() => commit('SET_LOADING', false))
  },

  UPDATE: ({ commit }, payload) => {
    commit('SET_SAVING', true)
    return http.patch(url, payload)
    .then(response => {
      commit('SET_SETTINGS', response.data)
      return response.data
    })
    .finally(() => commit('SET_SAVING', false))
  },

  RESET: ({ commit }) => {
    commit('SET_SETTINGS', null)
  }
}

const mutations = {
  SET_SETTINGS: (state, value) => {
    state.settings = value
  },
  SET_LOADING: (state, value) => {
    state.loading = value
  },
  SET_SAVING: (state, value) => {
    state.saving = value
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
